<template>
    <div class="leading-5">
        <span v-if="hasReferencePrice">
            ({{ referencePrice }}* / {{ price.referencePrice.referenceUnit }} {{ price.referencePrice.unitName }})
        </span>
        <span v-else-if="hasValidPurchaseUnit">
            ({{ formatPrice(price.regularPrice) }} / {{ formattedPurchaseUnit }} {{ product?.unit?.translated?.name }})
        </span>
    </div>
</template>

<script setup lang="ts">
import { useCurrency } from '#imports'

const { formatPrice } = useCurrency()

const props = defineProps<{
    product?: any,
}>()

const price = computed(() => props.product?.calculatedPrice || props.product?.price || {})

const hasValidPurchaseUnit = computed(() =>
    props.product?.purchaseUnit &&
    props.product.purchaseUnit > 0 &&
    props.product.unit?.translated?.name
)

const formattedPurchaseUnit = computed(() =>
    props.product?.purchaseUnit?.toLocaleString('de-DE')
)

const hasReferencePrice = computed(() => price.value?.referencePrice != null)

const referencePrice = computed(() => {
    const specialBase = props.product?.customFields?.special_base_price
    if (specialBase != null) return specialBase
    return formatPrice(price.value?.referencePrice?.price)
})
</script>
